/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M.25 4.653C.25 2.0834 2.3333 0 4.903 0h12.7348c2.5698 0 4.653 2.0833 4.653 4.653v11.7552a.7347.7347 0 0 1-1.4694 0V4.6531c0-1.7583-1.4254-3.1837-3.1836-3.1837H4.9031c-1.7583 0-3.1837 1.4254-3.1837 3.1837v14.6938c0 1.7583 1.4254 3.1837 3.1837 3.1837h12.7347a.7346.7346 0 0 1 .7346.7347.7346.7346 0 0 1-.7346.7347H4.9031C2.3332 24 .25 21.9168.25 19.3469V4.6531Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.2624 15.4632a6.3403 6.3403 0 0 0 1.3754-3.953c0-3.5166-2.8508-6.3673-6.3674-6.3673s-6.3673 2.8507-6.3673 6.3673c0 3.5166 2.8507 6.3674 6.3673 6.3674a6.3403 6.3403 0 0 0 3.953-1.3754l7.2826 7.2826a.7347.7347 0 0 0 1.039-1.039l-7.2826-7.2826Zm-4.992.945c2.7051 0 4.898-2.1929 4.898-4.898 0-2.705-2.1929-4.898-4.898-4.898-2.705 0-4.898 2.193-4.898 4.898 0 2.7051 2.193 4.898 4.898 4.898Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'Trace'
);
